// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.side-bar-controls {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 56px;
  width: calc(100% - 32px);
}

.side-bar-menu-toggle {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  cursor: pointer;
  color: rgb(71, 71, 71);
}

.side-bar-menu-toggle ion-icon {
  font-size: 24px;
  color: rgb(100, 100, 100);
}

.side-bar-search-input {
  flex: 1 1 auto;
  min-width: 0;
  margin: 0 10px;
}

/* Ensure other controls in the same flex row do not shrink */
.side-bar-controls > *:not(.side-bar-search-input) {
  flex-shrink: 0;
}

.side-bar-cancel-search {
  color: rgb(222, 72, 88);
  font-family: Roboto, sans-serif;
  font-size: 15px;
  font-weight: bold;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/Page/Conversations/SideBar/Controls.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,cAAc;AAChB;;AAEA,6DAA6D;AAC7D;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB","sourcesContent":[".side-bar-controls {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  height: 56px;\n  width: calc(100% - 32px);\n}\n\n.side-bar-menu-toggle {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  height: 40px;\n  cursor: pointer;\n  color: rgb(71, 71, 71);\n}\n\n.side-bar-menu-toggle ion-icon {\n  font-size: 24px;\n  color: rgb(100, 100, 100);\n}\n\n.side-bar-search-input {\n  flex: 1 1 auto;\n  min-width: 0;\n  margin: 0 10px;\n}\n\n/* Ensure other controls in the same flex row do not shrink */\n.side-bar-controls > *:not(.side-bar-search-input) {\n  flex-shrink: 0;\n}\n\n.side-bar-cancel-search {\n  color: rgb(222, 72, 88);\n  font-family: Roboto, sans-serif;\n  font-size: 15px;\n  font-weight: bold;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
